import waitingChatIconGif from './waitingChatIcon.gif';
export { waitingChatIconGif, };
